module.exports = __webpack_public_path__ + "static/scale-model-of-acadiana-in-lafayette-louisiana-d0f9b36d6213333f474e11fdc21330d7.png";